import { Box, Button, Paper, Typography } from '@mui/material';
import { useStaticLinks } from 'probonio-shared-ui/module/links/hooks';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { FullWidthCenterBox } from '../../../component/layout/BoxLayout';
import { withPreselectedRole } from '../../bikeleasingV2/bikeleasingPortalLink';
import { useBikeleasingDetails } from './useBikeleasingDetails';

export const BikeleasingRegister: React.FC = () => {
  const { t } = useTranslation('benefitModule');

  const bikeleasingDetails = useBikeleasingDetails();
  const links = useStaticLinks();

  if (!bikeleasingDetails || bikeleasingDetails.bikeleasingEmployeeInformation.length) {
    return null;
  }

  return (
    <Box sx={{ marginBottom: 1, marginTop: 1 }}>
      <Paper sx={{ boxShadow: 0, p: 1 }} data-test-id={'bikeleasing-register'}>
        {links?.BLS_PORTAL_USER && (
          <Typography
            sx={{
              mb: 1,
            }}
          >
            <Trans i18nKey={'benefitModule:benefit.BIKELEASING.alreadyRegisteredInfo'}>
              <a href={withPreselectedRole(links.BLS_PORTAL_USER)} target="_blank" rel="noreferrer"></a>
            </Trans>
          </Typography>
        )}
        <Typography
          sx={{
            mb: 1,
          }}
        >
          <Trans>{t('benefit.BIKELEASING.registerNowInfo')}</Trans>
        </Typography>

        {links?.BLS_PORTAL_REG && (
          <FullWidthCenterBox>
            <Button variant="contained" href={withPreselectedRole(links.BLS_PORTAL_REG)}>
              {t('benefit.BIKELEASING.registerNow')}
            </Button>
          </FullWidthCenterBox>
        )}
      </Paper>
    </Box>
  );
};
